/* 申込情報 */
import React from 'react';

interface Props {
  ja_name: string;
  reception_cd: string;
}

const ApplicationInformation: React.FC<Props> = ({ ja_name, reception_cd }) => {
  return (
    <div id="application-information">
      <p>申込先JA</p>
      <p>
        <b>{ja_name}</b>
      </p>
      <p>申込番号</p>
      <p>
        <b>{reception_cd}</b>
      </p>
      <p>申込番号はお問い合わせ等の場合に必要となります。</p>
    </div>
  );
};

export default ApplicationInformation;
